import type { User } from "../types";

import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  user: User | null;
  token: string | null;
  isLoggedIn: boolean;
  login: (user: User, token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isLoggedIn: false,
      login: (user: User, token: string) => {
        set({ user, token, isLoggedIn: true });
        localStorage.setItem("token", token);
      },
      logout: () => {
        set({ user: null, token: null, isLoggedIn: false });
        localStorage.removeItem("token");
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isLoggedIn: state.isLoggedIn,
      }),
    },
  ),
);
